export const GET_CLASS_SYMPTOM_SUCCESS = 'GET_CLASS_SYMPTOM_SUCCESS'
export const GET_CLASS_SYMPTOM_FAIL = 'GET_CLASS_SYMPTOM_FAIL'
export const GET_CLASS_SYMPTOM_CLEAR_DATA = 'GET_CLASS_SYMPTOM_CLEAR_DATA'
